module.exports = __webpack_public_path__ + "static/media/p0_2.abf0545c.png";